import { Material } from "./material"
export { Material }

export type RGB = [number, number, number]
const GREY:          RGB = [192, 192, 192]
const PINK:          RGB = [255, 105, 180]
const CHARTREUSE:    RGB = [ 92, 173,   5]
const GOLD:          RGB = [252, 203,   0]
const WHITE:         RGB = [255, 255, 255]
const PALE_BLUE:     RGB = [150, 158, 206]
const BLACK:         RGB = [  0,   0,   0]
const GREEN:         RGB = [ 55, 214, 122]
const BRIGHT_GREEN:  RGB = [102, 255,   0]
const ORANGE:        RGB = [255, 128,   0]
const PURPLE:        RGB = [153,  51, 255]
const REDDISH_PINK:  RGB = [214,  34, 104]
const LIGHT_PURPLE:  RGB = [189, 181, 250]
const BROWN:         RGB = [194,  94,  83]
const PASTEL_YELLOW: RGB = [249, 197,  83]
const PASTEL_GREEN:  RGB = [119, 221, 119]
const DARK_GREEN:    RGB = [0,    90,   0]
const FOREST_GREEN:  RGB = [20,  143, 119]
const LAVENDER:      RGB = [230, 230, 250]
const GREY_BLUE:     RGB = [40,  116, 166]

//Red Pallet
const A1_RED:        RGB = [255, 163, 130]
const A2_RED:        RGB = [255, 158, 158]
const A3_RED:        RGB = [205,  92,  92]
const A4_RED:        RGB = [255,  69,   0]
const A5_RED:        RGB = [178,  34,  34]


export const MATERIALS = {
  background:                     new Material([  0,   0,   0], 35,  0.3),
  default:                        new Material(GREY,            35,  0.3),
  stentGrey:                      new Material(GREY,            100, 0.4),
  kidneyBrown:                    new Material([194,  94,  83], 40, 0.34, GREY),
  kidneyPink:                     new Material([255, 192, 203], 40, 0.34, GREY),
  adrenalMustard:                 new Material([255, 219,  88], 40, 0.34),
  excretoryGold:                  new Material(GOLD,            50,  0.3),
  excretoryWhite:                 new Material(WHITE,           50,  0.3),
  seaGreen:                       new Material([ 90, 166, 150], 55,  0.4),
  seaGreenDark:                   new Material([ 58, 110,  86], 55,  0.4),
  arteryRed:                      new Material([202,  20,  25], 50,  0.4),
  veinBlue:                       new Material([ 18, 115, 222], 35,  0.3),
  veinDetailBlue:                 new Material([150, 205, 255], 35,  0.3),
  spleenPurple:                   new Material([ 70,  35,  92], 35,  0.3),
  boneCream:                      new Material([193, 205, 205], 40,  0.4),
  liverPurple:                    new Material([94,   25,  20], 40, 0.34),
  stomachGeraldine:               new Material([245, 155, 147], 50,  0.3),
  bladderOrange:                  new Material([255, 150,   0], 45,  0.3),
  renalSinusFatTangerine:         new Material([255, 216, 174], 40,  0.4),
  stoneTan:                       new Material([141,  77,  40], 50,  0.3),
  portalVeinCyan:                 new Material([153, 204, 255], 45,  0.4),
  bileDuctGreen:                  new Material([154, 205,  50], 45,  0.4),
  gallBladderGreen:               new Material([  0,  80,  50], 45,  0.4),
  lungWhole:                      new Material(PALE_BLUE,       45,  0.4),
  lobeSegmentGrey:                new Material(GREY,            45,  0.4),
  lobeLeftInferiorColour:         new Material(DARK_GREEN,      45,  0.4, DARK_GREEN, BLACK),
  lobeLeftSuperiorColour:         new Material(LAVENDER,        45,  0.4, LAVENDER, BLACK),
  lobeRightInferiorColour:        new Material(CHARTREUSE,      45,  0.4, CHARTREUSE, BLACK),
  lobeRightMedialColour:          new Material(GOLD,            45,  0.4, GOLD, BLACK),
  lobeRightSuperiorColour:        new Material(PALE_BLUE,       45,  0.4, PALE_BLUE, BLACK),
  airwayYellow:                   new Material([255, 255,   0], 30,  0.4),
  airwayOrange:                   new Material([250, 205, 120], 45,  0.3),
  veinUncertainDarkBlue:          new Material([  0,   0, 160], 45,  0.4),
  arteryUncertainMaroon:          new Material([102,   6,   6], 45,  0.4),
  muscleRed:                      new Material([221, 138, 138], 35,  0.3),
  rectusAbdominisRed:             new Material([221, 138, 138], 35,  0.3),
  transverseAbsOrange:            new Material([201,  99,  99], 35,  0.3),
  crusColour:                     new Material(ORANGE,          35,  0.3),
  thoracicDuctColour:             new Material(PASTEL_YELLOW,   35,  0.3),
  bodyChartreuse:                 new Material(CHARTREUSE     , 45,  0.4, GREY),
  skinColour:                     new Material([198, 134, 66] , 45,  0.4, GREY),
  colonRose:                      new Material([253, 234, 224], 40,  0.4),
  nervePink:                      new Material(PINK,            45,  0.4),
  nerveGold:                      new Material(GOLD,            45,  0.4),
  oesophagusColour:               new Material([128, 128,   0], 45,  0.4),
  prostateBlue:                   new Material([181, 225, 249], 40,  0.4),
  prostateCentralZoneColour:      new Material(BROWN,           40,  0.3),
  prostatePeripheralZoneColour:   new Material([255, 225, 103], 40,  0.3),
  prostateTransitionalZoneColour: new Material([255, 183, 242], 40,  0.3),
  prostateAFSColour:              new Material([ 43, 138, 145], 40,  0.3),
  pancreasSaffron:                new Material([254, 219,  46], 45,  0.3),
  bowelPink:                      new Material([255, 162, 183], 45,  0.3),
  urethraYellow:                  new Material([240, 238, 160], 45,  0.4),
  seminalVesicleColour:           new Material([189, 181, 250], 45,  0.4),
  ovaryPink:                      new Material([187,  64, 111], 45,  0.4),
  uterusPink:                     new Material([246, 187, 208], 45,  0.4),
  mesorectumYellow:               new Material([254, 240, 119], 45,  0.4),
  rectumPink:                     new Material([224,  84, 100], 45,  0.4),
  slamPurple:                     new Material([221, 160, 221], 40, 0.34),
  lymphPink:                      new Material(PINK,            40, 0.34),
  tetheringGreen:                 new Material([ 70, 255, 130], 15,  0.4),
  tumourGreen:                    new Material([ 55, 214, 122], 15,  0.4),
  tumourDarkGreen:                new Material([ 22, 107,  61], 15,  0.4),
  tumourYellow:                   new Material([240, 238, 160], 15,  0.4),
  tumourDarkYellow:               new Material([120, 119,  80], 15,  0.4),
  tumourRed:                      new Material([220, 100, 100], 15,  0.4),
  tumourDarkRed:                  new Material([110,  50,  50], 15,  0.4),
  lesionUncertainOrange:          new Material(ORANGE,          15,  0.4),
  heartMyocardiumColour:          new Material([138,  45,  30], 45,  0.4),
  heartPurple:                    new Material([176,  13, 221], 45,  0.4),
  heartVentricleRightColour:      new Material([249, 168, 255], 45,  0.4),
  cystPurple:                     new Material([144,  46, 193], 40,  0.4),
  a1:                             new Material(A1_RED,          40,  0.5, A1_RED, A1_RED),
  a2:                             new Material(A2_RED,          40,  0.5, A2_RED, A2_RED),
  a3:                             new Material(A3_RED,          40,  0.5, A3_RED, A3_RED),
  a4:                             new Material(A4_RED,          40,  0.5, A4_RED, A4_RED),
  a5:                             new Material(A5_RED,          40,  0.5, A5_RED, A5_RED),
  a6:                             new Material(A1_RED,          45,  0.5, A1_RED, A1_RED),
  a7:                             new Material(A2_RED,          40,  0.5, A2_RED, A2_RED),
  a8:                             new Material(A3_RED,          45,  0.5, A3_RED, A3_RED),
  a9:                             new Material(A4_RED,          45,  0.5, A4_RED, A4_RED),
  a10:                            new Material(A5_RED,          45,  0.5, A5_RED, A5_RED),
  a1segmentLeft:                  new Material([155, 200, 0],   40,  0.5),
  a2segmentLeft:                  new Material(REDDISH_PINK,    40,  0.5),
  a3segmentLeft:                  new Material(BRIGHT_GREEN,    40,  0.5),
  a4segmentLeft:                  new Material(GREEN,           40,  0.5),
  a5segmentLeft:                  new Material([155, 100, 0],   40,  0.5),
  a6segmentLeft:                  new Material(BROWN,           45,  0.5),
  a7segmentLeft:                  new Material(DARK_GREEN,      40,  0.5),
  a8segmentLeft:                  new Material(PINK,            45,  0.5),
  a9segmentLeft:                  new Material([155, 250, 100], 45,  0.5),
  a10segmentLeft:                 new Material(ORANGE,          45,  0.5),
  a1segmentRight:                 new Material([255,  70, 160], 40,  0.5),
  a2segmentRight:                 new Material(REDDISH_PINK,    40,  0.5),
  a3segmentRight:                 new Material(BRIGHT_GREEN,    40,  0.5),
  a4segmentRight:                 new Material(LIGHT_PURPLE,    40,  0.5),
  a5segmentRight:                 new Material([255, 130, 70],  40,  0.5),
  a6segmentRight:                 new Material(PASTEL_YELLOW,   45,  0.5),
  a7segmentRight:                 new Material([200, 150, 130], 40,  0.5),
  a8segmentRight:                 new Material([155, 130, 0],   45,  0.5),
  a9segmentRight:                 new Material([200, 130, 190], 45,  0.5),
  a10segmentRight:                new Material([155, 100, 0],   45,  0.5),
  v1segment:                      new Material([230, 230, 250], 40,  0.5),
  v2segment:                      new Material([173, 216, 230], 40,  0.5),
  v3segment:                      new Material([135, 206, 250], 40,  0.5),
  v4segment:                      new Material([0  , 191, 255], 40,  0.5),
  v5segment:                      new Material([30 , 144, 255], 40,  0.5),
  v6segment:                      new Material([70 , 130, 180], 45,  0.5),
  v7segment:                      new Material([106,  90, 205], 40,  0.5),
  v8segment:                      new Material([0  ,   0, 255], 45,  0.5),
  v9segment:                      new Material([0  ,   0, 133], 45,  0.5),
  v10segment:                     new Material([75 ,   0, 130], 45,  0.5),
  v11segment:                     new Material([128 ,  0, 128], 45,  0.5),
  v12segment:                     new Material([128 , 10, 228], 45,  0.5),
  s1:                             new Material(GOLD,            40,  0.5, GOLD, GOLD),
  s2:                             new Material(PURPLE,          40,  0.5, PURPLE, PURPLE),
  s3:                             new Material(FOREST_GREEN,    40,  0.5, FOREST_GREEN, FOREST_GREEN),
  s4:                             new Material(BROWN,           40,  0.5, BROWN, BROWN),
  s5:                             new Material(GREY,            40,  0.5, GREY, GREY),
  s6:                             new Material(ORANGE,          45,  0.5, ORANGE, ORANGE),
  s7:                             new Material(PASTEL_GREEN,    40,  0.5, PASTEL_GREEN, PASTEL_GREEN),
  s8:                             new Material(PINK,            45,  0.5, PINK, PINK),
  s9:                             new Material(LIGHT_PURPLE,    45,  0.5, LIGHT_PURPLE, LIGHT_PURPLE),
  s10:                            new Material(GREY_BLUE,       45,  0.5, GREY_BLUE, GREY_BLUE),
  pelvisLeftColour:               new Material([  0,  60,   0], 40,  0.4),
  sacrumColour:                   new Material([ 70, 108,   0], 40,  0.4),
  pelvisRightColour:              new Material([140, 180,   0], 40,  0.4),
  calcificationColour:            new Material([232, 232, 173], 60,  0.4),
  // need assigning to a label index
  // airwayWhite:                    new Material([210, 210, 210], 30,  0.4),
  // aortaRed:                       new Material([162,   0,   4], 45,  0.4),
  // implantPurple:                  new Material([221, 160, 221], 40, 0.34, GREY),
  // pulmonaryArteryRed:             new Material([141,   0,   4], 45,  0.4, [255, 162, 162]),
  // pulmonaryVeinBlue:              new Material([ 13,  81, 155], 45,  0.4, [135, 206, 250]),
  // venaCavaBlue:                   new Material([ 14,  92, 178], 45,  0.4),
  // metalGrey:                      new Material(LIGHT_GREY,     235,  0.4),
} as const

// This next line is only to enforce Record<?, Material> for MATERIALS i.e. that each value is a valid Material.
// eslint-able-next-line @typescript-eslint/no-unused-vars
const _dummyMaterials: Record<string, Material> = MATERIALS

export type MaterialName = keyof typeof MATERIALS
export const MATERIAL_NAMES = Object.keys(MATERIALS) as readonly MaterialName[]
